var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthBenefits = function SvgHealthBenefits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.024 21.08a12.75 12.75 0 0 1-8.096-3.715 12.75 12.75 0 0 1-3.715-8.093l-7.555 7.555a8 8 0 0 0 0 11.314l.496.495a8 8 0 0 0 11.313 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.205 9.272 6.324-6.324a8 8 0 0 1 11.313 0l.496.495a8 8 0 0 1 0 11.314l-6.325 6.324a12.75 12.75 0 0 1-8.094-3.714 12.75 12.75 0 0 1-3.714-8.095",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M19.703 5.086a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgHealthBenefits;